import { Component, OnInit } from '@angular/core';
import { GlobalsPaths } from '../app.config';
import { Router } from '@angular/router';
import { UsersService } from '../_services/users.service';
import { AuthenticationService } from 'app/_services';
import { UserSSO, UserSSOPermission } from 'app/_models/user';
import { environment } from 'environments/environment';

@Component({
  moduleId: module.id,
  selector: 'home-app',
  templateUrl: `./home.html`,
})

export class HomeComponent implements OnInit {
  userInfo: any = {};
  img: string = this.globalsPaths.img;
  newUserInfo: UserSSO;

  permissionMatrix: {
    DEFECT?: boolean,
    DATALIVE?: boolean
    SAFETY_INSPECTION?: boolean,
    DRIVER_AGENCY_ONBOARDING?: boolean,
    FMT?: boolean,
    ER_DASHBOARD?: boolean,
    VEHICLE_UTILISATION?: boolean
  } = {};
  defectAppUrl: string = environment.defectAppUrl;
  safetyInspectionAppUrl: string = environment.safetyInspectionAppUrl;
  vehicleUtilisationAppUrl: string = environment.vehicleUtilisationAppUrl;
  erDashboardAppUrl: string = environment.externalAppLinks.ER_DASHBOARD;
  tachoGrafAppUrl: string = environment.externalAppLinks.TACHOGRAF;
  agencyOnboardingAppUrl: string = environment.externalAppLinks.DRIVER_AGENCY_ONBOARDING;

  devPermissionSet = [
    {
        "ExternalAppId": 1,
        "ExternalAppName": "Datalive",
        "ExternalAppReference": "datalive",
        "Id": 1,
        "IsCustomerAdmin": false,
        "IsEngineer": false,
        "IsGlobalAdmin": true,
        "IsManager": false,
        "IsReadonly": false,
        "IsRepairer": false,
        "IsServerUser": false,
        "IsUserVehicleAdmin": false,
        "Level": 3,
        "PermissionName": "Datalive  Admin"
    },
    {
        "ExternalAppId": 2,
        "ExternalAppName": "Datalive Defect",
        "ExternalAppReference": "DEFECT",
        "Id": 2,
        "IsCustomerAdmin": true,
        "IsEngineer": true,
        "IsGlobalAdmin": false,
        "IsManager": true,
        "IsReadonly": false,
        "IsRepairer": false,
        "IsServerUser": false,
        "IsUserVehicleAdmin": false,
        "Level": 3,
        "PermissionName": "Defect Admin"
    },
    {
        "ExternalAppId": 2,
        "ExternalAppName": "Datalive Defect",
        "ExternalAppReference": "DEFECT",
        "Id": 3,
        "IsCustomerAdmin": false,
        "IsEngineer": false,
        "IsGlobalAdmin": false,
        "IsManager": false,
        "IsReadonly": false,
        "IsRepairer": true,
        "IsServerUser": false,
        "IsUserVehicleAdmin": false,
        "Level": 2,
        "PermissionName": "Defect Repairer"
    },
    {
        "ExternalAppId": 2,
        "ExternalAppName": "Datalive Defect",
        "ExternalAppReference": "DEFECT",
        "Id": 4,
        "IsCustomerAdmin": false,
        "IsEngineer": false,
        "IsGlobalAdmin": false,
        "IsManager": false,
        "IsReadonly": false,
        "IsRepairer": false,
        "IsServerUser": false,
        "IsUserVehicleAdmin": false,
        "Level": 1,
        "PermissionName": "Defect Limited"
    },
    {
        "ExternalAppId": 3,
        "ExternalAppName": "Datalive Safety Inspection",
        "ExternalAppReference": "SAFETY_INSPECTION",
        "Id": 5,
        "IsCustomerAdmin": false,
        "IsEngineer": false,
        "IsGlobalAdmin": false,
        "IsManager": false,
        "IsReadonly": false,
        "IsRepairer": false,
        "IsServerUser": false,
        "IsUserVehicleAdmin": false,
        "Level": 1,
        "PermissionName": "Safety Inspection Brake Test Uploader"
    },
    {
        "ExternalAppId": 3,
        "ExternalAppName": "Datalive Safety Inspection",
        "ExternalAppReference": "SAFETY_INSPECTION",
        "Id": 6,
        "IsCustomerAdmin": false,
        "IsEngineer": false,
        "IsGlobalAdmin": false,
        "IsManager": true,
        "IsReadonly": false,
        "IsRepairer": false,
        "IsServerUser": false,
        "IsUserVehicleAdmin": false,
        "Level": 2,
        "PermissionName": "Safety Inspection Manager"
    },
    {
        "ExternalAppId": 5,
        "ExternalAppName": "Datalive Driver Agency Onboarding",
        "ExternalAppReference": "DRIVER_AGENCY_ONBOARDING",
        "Id": 7,
        "IsCustomerAdmin": false,
        "IsEngineer": false,
        "IsGlobalAdmin": false,
        "IsManager": true,
        "IsReadonly": false,
        "IsRepairer": false,
        "IsServerUser": false,
        "IsUserVehicleAdmin": false,
        "Level": 1,
        "PermissionName": "Agency Onboarding"
    },
]
  showAllModules = false;
  customerLogo: string = '';
  showCustomerLogo = false;

  constructor(private globalsPaths: GlobalsPaths,
    private router: Router,
    private usersService: UsersService,
    private authenticationService: AuthenticationService,
  ) { }

  async ngOnInit() {
    const _currentUser = localStorage.getItem('currentUser');

    /**
     * get the user info from the sso api
     * and set the validity of whether the user has access to certain apps
     */
    this.newUserInfo = await this.usersService.getNewUserInfo()
    console.log('Home newUserInfo: ', this.newUserInfo);
    if ((!this.newUserInfo || !this.newUserInfo.extra_vars || !this.newUserInfo.extra_vars.permissions) && environment.production) {
      this.authenticationService.logout();
      window.location.href = '/';
    }
    if ( environment.production ) {
      this.newUserInfo.extra_vars.permissions.forEach((perm) => this.permissionMatrix[perm.ExternalAppReference] = true);
    } else {
      this.devPermissionSet.forEach((perm) => this.permissionMatrix[perm.ExternalAppReference] = true);
    }
   

    if (_currentUser !== null) {
      const _user = JSON.parse(_currentUser);
      this.userInfo = _user.user;

      const custConfig = await this.authenticationService.GetCurrentCustomer();
      debugger
      if (custConfig && custConfig.customer_config) {
        this.showCustomerLogo = custConfig.customer_config.render_cust_logo_on_dl_homescreen;
      } else {
        this.authenticationService.logout();
      }
    
      const customer = this.userInfo.customers[0];
      if (customer && customer.logo && this.showCustomerLogo) {
        this.customerLogo = customer.logo;
      } else {
        this.customerLogo = `${this.img}datalive-logo-white.png`;
      }
      
      console.log(this.userInfo);
    } else {
      console.log('_currentUser is NOT present ');
      this.router.navigate(['/login']);
    }

    
   
  }

  /**
   * @description Opens app in a new window.
   * @param app 
   */
  openApp(app: UserSSOPermission) {
    const link = environment.externalAppLinks[app.ExternalAppReference];
    if (link) {
      window.open(link);
    }
  }

  public expandAllModules() {
    this.showAllModules =! this.showAllModules;
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Home/home.component.ts